const _BAD = window.kef.book_a_demo;
const _BAD_TEXTS = _BAD.texts;
const _BAD_ARIA_TEXTS = _BAD.aria_texts;
const wrapper_id = '#book-a-demo';

const book_a_demo = {
  step: '',
  slider: false,
  splide: {
    el: null,
    updateHeight: () => { 
      var splide = book_a_demo.splide.el;
      let idx = splide.index;
      let slide = splide.Components.Slides.getAt(idx);
      setTimeout(() => {
        $(splide.root).css({
          'height': $('> div', $(slide.slide)).outerHeight()+'px',
        });
      }, 300);
    },
    init: () => {
      var style = document.createElement('link');
      style.href = 'https://cdn.jsdelivr.net/npm/@splidejs/splide/dist/css/splide.min.css';
      style.rel = 'stylesheet';
      document.getElementsByTagName('head')[0].appendChild(style);

      var script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/@splidejs/splide/dist/js/splide.min.js';
      script.type = 'text/javascript';
      document.getElementsByTagName('head')[0].appendChild(script);

      script.onload = book_a_demo.splide.initScript;
    },
    initScript: () => {
      book_a_demo.splide.el = new Splide(`${wrapper_id} .splide`, {
        type: 'slide',
        width: '100%',
        gap: 0,
        padding: 0,
        arrows: false,
        pagination: true,
        drag: false,
        autoplay: false,
        keyboard: false,
        wheel: false,
      });

      book_a_demo.splide.el.on('mounted', (e) => {
        book_a_demo.splide.checkStep();

        book_a_demo.splide.updateHeight();
      });
      book_a_demo.splide.el.on('ready', (e) => {
        book_a_demo.splide.updateHeight();
      });
      book_a_demo.splide.el.on('resize', (e) => {
        book_a_demo.splide.updateHeight();
      });
      book_a_demo.splide.el.on('resized', (e) => {
        book_a_demo.splide.updateHeight();
      });
      book_a_demo.splide.el.on('active', (e) => {
        book_a_demo.splide.updateHeight();

        var splide = book_a_demo.splide.el;
        let idx = splide.index;
        let slide = splide.Components.Slides.getAt(idx);

        // move nav
        $('> .book-demo-wrapper-nav', wrapper_id).remove();
        let slide_nav = $('.book-demo-wrapper-nav', $(slide.slide));
        if (slide_nav.length > 0) {
          var slide_nav_html = slide_nav[0].outerHTML;
          $(wrapper_id).append(slide_nav_html);
          slide_nav.hide();
        }

        $('html,body').stop().animate({
          scrollTop: 0,
        }, 300);
      });
      book_a_demo.splide.el.on('move', (e) => {
        $('> .book-demo-wrapper-nav', wrapper_id).remove();
      });
      book_a_demo.splide.el.on('pagination:updated', (e) => {
        var splide = book_a_demo.splide.el;
        let idx = splide.index;
        let page = splide.Components.Pagination.getAt(idx);
        $(page.li).addClass('is-active').siblings().removeClass('is-active');
      });
      book_a_demo.splide.el.mount();
  
      $('.btn-prev-step', wrapper_id).on('click', () => {
        book_a_demo.splide.slidePrev();

        // gtm
      });

      // btn prev
      $(wrapper_id).off('click', '> .book-demo-wrapper-nav .btn-prev-step');
      $(wrapper_id).on('click', '> .book-demo-wrapper-nav .btn-prev-step', function(e) {
        book_a_demo.splide.slidePrev();
        e.preventDefault();
        
        // gtm
      });

      // btn next
      $(wrapper_id).off('click', '> .book-demo-wrapper-nav button[type="submit"]');
      $(wrapper_id).on('click', '> .book-demo-wrapper-nav button[type="submit"]', function(e) {
        var form = $('form', book_steps.el);
        if (form.length > 0) {
          form.submit();
        }
        e.preventDefault();
        
        // gtm
      });
  
      $('form', wrapper_id).on('keypress', (e) => {
        if ((e.charCode || e.keyCode || 0) == 13) {
          e.preventDefault();
        }
      });
    },
    updateEl: () => {
      setTimeout(() => book_a_demo.splide.el.refresh(), 300);
    },
    slidePrev: () => {
      book_a_demo.validator.destroy();
  
      var splide = book_a_demo.splide.el;
      let idx = splide.index;
      splide.go(idx-1);
      book_a_demo.splide.checkStep();
    },
    slideNext: () => {
      var splide = book_a_demo.splide.el;
      let idx = splide.index;
      splide.go(idx+1);
      book_a_demo.splide.checkStep();
    },
    checkStep: () => {
      var splide = book_a_demo.splide.el;
      let idx = splide.index;
      let slide = splide.Components.Slides.getAt(idx);
      let slide_id = $(slide.slide).data('id').trim();
  
      book_steps.init(slide_id, $(slide.slide));
    },
    destroyEl: () => {
      var splide = book_a_demo.splide.el;
      splide.root.querySelector('.splide__pagination').style.display = 'none';
      splide.options.pagination = false;
    },
  },
  swiper: {
    el: null,
    init: () => {
      book_a_demo.swiper.initScript();
    },
    initScript: () => {
      book_a_demo.swiper.el = new Swiper(`${wrapper_id} .swiper`, {
        direction: 'horizontal',
        loop: false,
        spaceBetween: 0,
        preventInteractionOnTransition: true,
        slidesPerView: 1,
        // initialSlide: 1,
        simulateTouch: false,
        allowTouchMove: false,
        noSwiping: true,
        noSwipingClass: `${wrapper_id} .swiper-slide`,
        noSwipingSelector: `${wrapper_id} .swiper-slide`,
  
        autoplay: false,
        observer: true,
        observeParents: true,
        resizeObserver: false,
        autoHeight: true,
        pagination: {
          el: `${wrapper_id} .swiper-pagination`,
          type: 'progressbar',
        },
        // hashNavigation: {
        //   replaceState: true,
        // },
        on: {
          afterInit: (swiper) => {
            book_a_demo.swiper.checkStep(swiper);
          },
          slideChange: (swiper) => {
            $('html,body').stop().animate({
              scrollTop: 0,
            }, 300);
          },
        },
      });
      book_a_demo.swiper.el.on('afterInit', (swiper) => {
        book_a_demo.swiper.checkStep(swiper);
      });
  
      $('.btn-prev-step', wrapper_id).on('click', () => {
        book_a_demo.swiper.slidePrev();

        // gtm
      });
  
      $('form', wrapper_id).on('keypress', (e) => {
        if ((e.charCode || e.keyCode || 0) == 13) {
          e.preventDefault();
        }
      });
    },
    updateEl: () => {
      setTimeout(() => book_a_demo.swiper.el.update(), 300);
    },
    slidePrev: () => {
      book_a_demo.validator.destroy();
  
      book_a_demo.swiper.el.slidePrev();
      book_a_demo.swiper.checkStep();
    },
    slideNext: () => {
      book_a_demo.swiper.el.slideNext();
      book_a_demo.swiper.checkStep();
    },
    checkStep: (swiper) => {
      swiper = swiper || book_a_demo.swiper.el;
      let idx = swiper.activeIndex;
      let slide = $(swiper.slides[idx]);
      let slide_id = slide.data('id').trim();
  
      book_steps.init(slide_id, slide);
    },
    destroyEl: (swiper) => {
      swiper = swiper || book_a_demo.swiper.el;
      swiper.pagination.destroy();
    },
  },
  map: {
    el: null,
    init: (id) => {
      id = id || 'dealer-locator';

      if (typeof A === 'undefined') {
        var map_style = document.createElement('link');
        map_style.href = _BAD.map_css+'?'+(new Date()).getTime();
        map_style.rel = 'stylesheet';
        document.getElementsByTagName('head')[0].appendChild(map_style);
  
        var map_script = document.createElement('script');
        map_script.src = _BAD.map_js+'?'+(new Date()).getTime();
        map_script.type = 'text/javascript';
        document.getElementsByTagName('head')[0].appendChild(map_script);
        
        map_script.onload = () => {
          A.init(id);
        }
      } else {
        A.init(id);
      }
    }
  },
  fullcalendar: {
    el: null,
    init: () => {
      if (book_a_demo.fullcalendar.el != null) {
        book_a_demo.fullcalendar.el.destroy();
      }

      let initial_date = new Date();
      if (_BAD.calendar_initial_date != '') {
        initial_date = luxon.DateTime.now().setZone(book_steps.datas['store'].timezone, { keepLocalTime: true }).toUTC();
        let c = _BAD.calendar_initial_date;
        let operand = c.slice(0,1);
        let val = c.slice(1);
        if (operand == '+') {
          initial_date = initial_date.plus({days: val})
        } else if (operand == '-') {
          initial_date = initial_date.minus({days: val})
        }
        initial_date = initial_date.toISO();
      }
  
      let el = document.getElementById('book-demo-appointment-calendar');
      book_a_demo.fullcalendar.el = new FullCalendar.Calendar(el, {
        locale: _BAD.locale,
        height: 456,
        initialView: 'dayGridMonth',
        customButtons: {
          'custom-prev': {
            click: function() {
              el.classList.add('loading');
              book_a_demo.fullcalendar.removeEventsCalendar();
              book_a_demo.fullcalendar.el.prev();
            }
          },
          'custom-next': {
            click: function() {
              el.classList.add('loading');
              book_a_demo.fullcalendar.removeEventsCalendar();
              book_a_demo.fullcalendar.el.next();
            }
          },
        },
        headerToolbar: {
          left: 'title',
          center: '',
          right: 'custom-prev,custom-next',
        },
        dayHeaderFormat: {
          weekday: 'narrow',
        },
        // showNonCurrentDates: false,
        firstDay: _BAD.calendar_first_day_week,
        initialDate: initial_date,
        fixedWeekCount: false,
        selectable: true,
        unselectAuto: false,
        rerenderDelay: 1000,
        longPressDelay: 1,
        select: function(info) {
          $('.book-demo-calendar-time-wrapper > div', $(el)).html('');
        },
        eventClick: function(info) {
          el.classList.add('loading');
          book_steps.calendar_form.initTimeWrapper(info.event.startStr);

          setTimeout(() => {
            $('.fc-state-highlight').removeClass('fc-state-highlight');
            $(info.el).parents('td.fc-day').addClass('fc-day-event').addClass('fc-state-highlight');
          }, 150);
        },
        dateClick: function(info) {
          $('.book-demo-calendar-time-wrapper > div', $(el)).html('');
          return false;
        },
        datesSet: function(info) {
          el.classList.add('loading');
          book_steps.inputs['start_date'] = luxon.DateTime.fromJSDate(new Date(info.view.currentStart)).setZone(book_steps.datas['store'].timezone, { keepLocalTime: true }).toUTC().toISO();
          book_steps.inputs['end_date'] = luxon.DateTime.fromJSDate(new Date(info.view.currentEnd)).setZone(book_steps.datas['store'].timezone, { keepLocalTime: true }).toUTC().minus({seconds: 1}).toISO();
          book_steps.calendar_form.initAjaxData();

          book_a_demo.validator.checkValidate(book_steps.id);
        },
        viewDidMount: function(arg) {
          el.classList.add('loading');
          $('.fc-custom-prev-button').html(_BAD.icon_arrow).attr('aria-label', _BAD_ARIA_TEXTS.previous);
          $('.fc-custom-next-button').html(_BAD.icon_arrow).attr('aria-label', _BAD_ARIA_TEXTS.next);
        },
        viewClassNames: function(arg) {
          el.classList.remove('loading');
  
          let trs = $('.fc-daygrid-body tr', $(el));
          let tr_length = trs.length;
          let multplier = tr_length + 2;
          let new_height = (multplier * 48) + ((multplier - 1) * 20);
          // book_a_demo.fullcalendar.el.setOption('height', new_height);
  
          $('.book-demo-calendar-time-wrapper', book_steps.el).css({
            maxHeight: new_height
          });
  
          let today = luxon.DateTime.fromJSDate(new Date()).setZone(book_steps.datas['store'].timezone, { keepLocalTime: true });
          let start = luxon.DateTime.fromJSDate(new Date(arg.view.currentStart)).setZone(book_steps.datas['store'].timezone, { keepLocalTime: true });
          let time_diff = start.diff(today, ['months']);
          let time_diff_obj = time_diff.toObject();
          time_diff_obj['months'] < 0
            ? $('.fc-custom-prev-button', el).hide().attr('disabled', 'disabled')
            : $('.fc-custom-prev-button', el).show().removeAttr('disabled');
  
          setTimeout(() => {
            if ($('.fc-highlight').parents('td.fc-day').find('.fc-bg-event').length > 0) {
              $('.fc-state-highlight').removeClass('fc-state-highlight');
              $('.fc-highlight').parents('td.fc-day').addClass('fc-state-highlight');
            }
            $('.fc-bg-event').parents('td.fc-day').addClass('fc-day-event');
          }, 150);
        },
      });
      book_a_demo.fullcalendar.el.render();
    },
    removeEventsCalendar: () => {
      // remove events
      $('.book-demo-calendar-time-wrapper > div').html('');
      let events = book_a_demo.fullcalendar.el.getEvents();
      for (let i in events) events[i].remove();
    },
    updateEventsCalendar: (slots, end_date) => {
      // add events
      let end_of_month = luxon.DateTime.fromISO(end_date).setZone(book_steps.datas['store'].timezone, { keepLocalTime: true }).toISODate();
      let date_slots = Object.keys(slots);
      $.each(slots, (date, slots_data) => {
        if (date <= end_of_month) {
          book_a_demo.fullcalendar.el.addEvent({
            title: '',
            start: date,
            display: 'background',
            allDay: true,
          });
        }
      });
  
      book_a_demo.fullcalendar.el.select(date_slots[0] || luxon.DateTime.now().setZone(book_steps.datas['store'].timezone, { keepLocalTime: true }).toISODate());
  
      book_steps.calendar_form.initTimeWrapper(date_slots[0] || luxon.DateTime.now().setZone(book_steps.datas['store'].timezone, { keepLocalTime: true }).toISODate(), 0);
    },
  },
  validator: {
    ivt: null,
    forms: {},
    setDefaults: () => {
      $.validator.setDefaults({
        ignore: '',
      });

      $('button[type="submit"]', wrapper_id).attr('disabled', 'disabled');

      $(wrapper_id).on('blur keyup change', `input, textarea, select`, function(event) {
        book_a_demo.validator.checkValidate(book_steps.id);
      });
    },
    validate: (opts) => {
      if (book_a_demo.validator.ivt != null) clearInterval(book_a_demo.validator.ivt);

      book_a_demo.validator.forms[book_steps.id] = $('form', book_steps.el).validate(opts);

      book_a_demo.validator.ivt = setInterval(() => {
        if ($('input, textarea, select', book_steps.el).length == 0) return;
        clearInterval(book_a_demo.validator.ivt);

        setTimeout(() => {
          book_a_demo.validator.checkValidate(book_steps.id);
        }, 500);
      }, 500);
    },
    checkValidate: (id) => {
      if (typeof book_a_demo.validator.forms[id] === 'undefined') return;

      let flag = book_a_demo.validator.forms[id].checkForm();

      let btn = $('button[type="submit"]', book_steps.el);
      let btn_alt = $('> .book-demo-wrapper-nav button[type="submit"]', wrapper_id);
      if (flag) {
        btn.removeAttr('disabled', 'disabled');
        btn_alt.removeAttr('disabled', 'disabled');
      } else {
        btn.attr('disabled', 'disabled');
        btn_alt.attr('disabled', 'disabled');
      }

      if (typeof book_a_demo.validator.forms[id] === 'undefined') return;

    },
    getValidate: (id) => {
      book_a_demo.validator.forms[id].form();
    },
    destroy: () => {
      // book_steps.validation.destroy();
      // book_steps.validation = null;
      $('.form-error').empty().show();
    },
  },

  init: () => {
    if (_BAD.json_enable) {
      $.ajax({
        method: 'GET',
        url: _BAD.json_url,
        dataType: 'json',
      }).done(function(data, textStatus, jqXHR) {
        book_steps.setJsonData(data);

        book_a_demo.initSlider();

      }).fail(function(jqXHR, textStatus, errorThrown) {
        
      });
    } else {
      book_a_demo.initSlider();
    }

  },
  initSlider: () => {
    if ($('.splide', wrapper_id).length > 0) {
      book_a_demo.slider = book_a_demo.splide;
    } else if ($('.swiper', wrapper_id).length > 0) {
      book_a_demo.slider = book_a_demo.swiper;
    }

    if (book_a_demo.slider !== false) {
      book_a_demo.slider.init();
      book_a_demo.validator.setDefaults();
    }
  },
}

const book_steps = {
  id: '',
  el: null,
  res: {},
  datas: {},
  inputs: {},
  validation: {},
  json: false,
  init: (id, el) => {
    book_steps.id = id;
    book_steps.el = el;

    if (!book_steps.hasOwnProperty(book_steps.id)) return;

    book_steps[id].init(el);
  },
  initAjax: (data) => {
    return $.ajax({
      method: 'GET',
      url: _BAD.lambda_url,
      data: data,
      dataType: 'json',
    });
  },
  setJsonData: (val) => {
    book_steps.json = val;
  },
  setExternalId: (val) => {
    book_steps.inputs['external_id'] = val;
  },
  pushGtm: (otps) => {
    if (typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push(otps);
    }
  },
  region_selection: {
    init: (el) => {
      book_steps.inputs['external_id'] = '';

      setTimeout(() => {
        book_a_demo.slider.updateEl();
      }, 300);

      book_a_demo.validator.validate({
        rules: {
          'region': {
            required: true,
          },
        },
        messages: {
          'region': {
            required: _BAD_TEXTS.region_selection.form.error.region,
          },
        },
        errorLabelContainer: '.region-selection-form-error',
        submitHandler: function(form) {
          book_steps.inputs['external_id'] = $('select[name="region"]', el).val();

          book_a_demo.validator.destroy();

          book_a_demo.slider.slideNext();

          return false;
        }
      });
    }
  },
  product_selection: {
    init: (el) => {
      book_steps.inputs['product_id'] = [];

      // if (book_steps.res.hasOwnProperty(book_steps.id)) return;

      if (book_steps.json !== false) {
        // var data = book_steps.json.product;
        var data = {}
        Object.entries(book_steps.json.store).forEach(function(store_data) {
          var product = store_data[0],
              stores = store_data[1]
          if (stores.length > 0) {
            data[product] = book_steps.json.product[product];
          }
        });
        book_steps.product_selection.setUi(el, {
          activities: Object.values(data)
        });
      } else {
        book_steps.initAjax({
          shop: _BAD.data_shop,
          action: 'product-selection',
          timestamp: _BAD.data_timestamp,
          signature: _BAD.data_signature,
  
          external_id: book_steps.inputs['external_id'] || '',
        }).done(function(data, textStatus, jqXHR) {
          book_steps.product_selection.setUi(el, data);
  
        }).fail(function(jqXHR, textStatus, errorThrown) {
          let hb_data = Object.assign({
            texts: _BAD_TEXTS['product-selection']['error_page'],
          });
          let tpl = Handlebars.compile($('#error-page-hb').html());
          $('.book-demo-product-list', el).html(tpl(hb_data));
        });
      }

      $(document).off('click', '.book-demo-product-option-1st');
      $(document).on('click', '.book-demo-product-option-1st', function(e) {
        var _t = $(this);
        var _t_input = _t.find('input');

        if (_t_input.attr('type') == 'radio') {
          _t.addClass('active')
            .siblings().removeClass('active')
            .find('input').prop('checked', false);

          _t_input.prop('checked', true).trigger('change');
        } else {
          if (! _t_input.prop('checked')) {
            _t.addClass('active');
            _t_input.prop('checked', true).trigger('change');
          } else {
            _t.removeClass('active');
            _t_input.prop('checked', false).trigger('change');
          }

          _t.siblings().removeClass('active')
            .find('input').prop('checked', false);
        }

        e.preventDefault();
      });

      book_a_demo.validator.validate({
        rules: {
          'product-option[]': {
            required: true,
          },
        },
        messages: {
          'product-option[]': {
            required: _BAD_TEXTS.product_selection.form.error.product,
          },
        },
        errorLabelContainer: '.product-selection-form-error',
        submitHandler: function(form) {
          book_steps.inputs['product_id'] = [];
          $('input[name="product-option[]"]:checked', el).each(function() {
            book_steps.inputs['product_id'].push($(this).val());
          });

          book_steps.datas['products'] = [];
          $('input[name="product-option[]"]:checked', el).each(function() {
            book_steps.datas['products'].push(JSON.parse($(this).attr('data-record')));
          });

          book_a_demo.validator.destroy();

          book_a_demo.slider.slideNext();

          // gtm
          book_steps.pushGtm({
            event: 'product_selection_next_step',
            gtmValue: book_steps.inputs['product_id'].join(','),
          });
          // hkmci
          pushToDataLayer('select_demo_product', {
            'item_id': book_steps.datas['products'][0]['activityExternalId'],
            'item_name': book_steps.datas['products'][0]['activityName'],
            'item_variant': '',
            'item_category': book_steps.datas['products'][0]['collectionName'],
            'item_category2': '',
          });

          return false;
        }
      });
    },
    setUi: (el, data) => {
      let products = [];
      let product = {};
      _BAD.product_data.forEach((product_data) => {
        product_data.handles.forEach((handle) => {
          var activity_product = data['activities'].filter(function(data) {
            return data.activityExternalId == handle;
          });
          if (activity_product.length == 0) return;
          product = activity_product[0];
          product['activityName'] = _BAD.product_texts.products[handle] || product['activityName'];
          product['collectionId'] = product_data.collection_handle;
          product['collectionName'] = _BAD.product_texts.categories[product_data.collection_handle] || product_data.title;
          products.push(product);
        });
      });
      // data.products = data['activities'];
      data.products = products;
      book_steps.res[book_steps.id] = data;

      let hb_data = Object.assign(data, {
        asset_url: _BAD.asset_url,
        input_id: 'book-demo-product-option-',
        input_name: 'product-option[]',
        input_selected: general.getUrlVars()['product'] || '',
        texts: _BAD_TEXTS['product_selection'],
      });
      let tpl = Handlebars.compile($('#product-selection-list-hb').html());
      $('.book-demo-product-list', el).html(tpl(hb_data));

      let param_product = general.getUrlVars()['product'] || '';
      if (param_product != '') {
        $('.book-demo-product-option input[value="'+param_product+'"]').prop('checked', true)
          .parents('.book-demo-product-option').addClass('active');
      }

      book_a_demo.slider.updateEl();
    },
  },
  store_locator: {
    init: (el) => {
      $('.book-demo-store-list', el).html('');

      if (book_steps.json !== false && _BAD.map_source == '') {
        var data = book_steps.json.store[book_steps.inputs['product_id'][0]];
        book_steps.store_locator.setUi(el, {
          'ns3:resources': data
        });
      } else {
        var ajaxes = [];
        $.each(book_steps.inputs['product_id'], (i, product_id) => {
          ajaxes.push(
            book_steps.initAjax({
              shop: _BAD.data_shop,
              action: 'store-locator',
              timestamp: _BAD.data_timestamp,
              signature: _BAD.data_signature,

              external_id: book_steps.inputs['external_id'] || '',
              product_id: product_id,
            })
          );
        });

        $.when(...ajaxes).done(function(...datas) {
          if (ajaxes.length == 1) {
            datas = [datas];
          }

          let first_data = datas.shift();
          first_data = first_data[0];
          $.each(datas, (i, data) => {
            var res = data[0];
            first_data['ns3:resources'] = first_data['ns3:resources'].filter((value) => {
              if (value == null) return false;
              return res['ns3:resources'].some((value2) => {
                if (value2 == null) return false;
                return (value.resourceExternalId === value2.resourceExternalId);
              });
            });
          });

          book_steps.store_locator.setUi(el, first_data);

        }).fail(function(fail) {
          let hb_data = Object.assign({
            texts: _BAD_TEXTS['store_locator']['error_page'],
          });
          let tpl = Handlebars.compile($('#error-page-hb').html());
          $('.book-demo-store-list', el).html(tpl(hb_data));
        });
      }

      $(document).off('click', '.dealer-locator nav ul.lists .list-item');
      $(document).on('click', '.dealer-locator nav ul.lists .list-item', function(e) {
        var _t = $(this);
        var _t_input = _t.find('input');
        _t_input.trigger('change');
        e.preventDefault();
      });

      book_a_demo.validator.validate({
        rules: {
          'store-option': {
            required: true,
          },
        },
        messages: {
          'store-option': {
            required: _BAD_TEXTS.store_locator.form.error.store,
          },
        },
        errorLabelContainer: '.store-locator-form-error',
        submitHandler: function(form) {
          var input_checked = $('input[name="store-option"]:checked', el);
          book_steps.inputs['store_id'] = '';
          book_steps.inputs['store_id'] = input_checked.val();

          // book_steps.datas['store'] = JSON.parse(input_checked.attr('data-record'));
          var store = JSON.parse(decodeURIComponent(input_checked.attr('data-record')));
          book_steps.datas['store'] = store;
          if (_BAD.map_enabled) {
            book_steps.datas['store']['display_name'] = store.name
            book_steps.datas['store']['resourceExternalId'] = store.sf_id;
            book_steps.datas['store']['description'] = `${store.address} ${store.city} ${store.country}`;
            book_steps.datas['store']['has_description'] = true;
          }

          book_a_demo.validator.destroy();

          book_a_demo.slider.slideNext();

          // gtm
          book_steps.pushGtm({
            event: 'store_locator_next_step',
            gtmValue: store.name,
          });
          // hkmci
          pushToDataLayer('select_demo_location', {
            'demo_location_store' : book_steps.datas['store']['name'],
            'demo_location_city' : book_steps.datas['store']['city'],
            'demo_location_country' : book_steps.datas['store']['country'],
            'item_id': book_steps.datas['products'][0]['activityExternalId'],
            'item_name': book_steps.datas['products'][0]['activityName'],
            'item_variant': '',
            'item_category': book_steps.datas['products'][0]['collectionName'],
            'item_category2': ''
          });

          return false;
        }
      });
    },
    setUi: (el, data) => {
      var map_ids = [];
      $.each(data['ns3:resources'], function(i, d) {
        if (d != null) {
          map_ids.push(d.resourceExternalId);
          data['ns3:resources'][i].has_description = d.description != '';
        }
      });
      data['ns3:resources'] = data['ns3:resources'].filter((value) => {
        return value != null;
      });
      data.stores = data['ns3:resources'];
      book_steps.res[book_steps.id] = data;

      if (_BAD.map_source != '') {
        map_ids_hardcode = _BAD.map_sf_id;
        map_ids = map_ids.filter(value => map_ids_hardcode.includes(value));
        if (map_ids.length == 0 && map_ids_hardcode.length > 0) map_ids = map_ids_hardcode;
      }

      let hb_data = Object.assign(data, {
        input_id: 'book-demo-store-option-',
        input_name: 'store-option',
        texts: _BAD_TEXTS['store_locator'],
        map: {
          data_country: _BAD.map_country,
          data_store: map_ids.join(','),
          zoom: _BAD.map_zoom,
          source: _BAD.map_source,
          lat: _BAD.map_lat,
          lng: _BAD.map_lng,
        },
      });
      let tpl = _BAD.map_enabled
        ? Handlebars.compile($('#store-list-hb').html())
        : Handlebars.compile($('#store-list-alt-hb').html());
      $('.book-demo-store-list', el).html(tpl(hb_data));

      book_a_demo.map.init('dealer-locator');

      var ivt = setInterval(() => {
        if ($('.book-demo-store-list .dealer-locator', el).html() != '') {
          clearInterval(ivt);
          book_a_demo.slider.updateEl();

          if (data.stores.length == 0) {
            $('button[type="submit"]', el).attr('disabled', 'disabled');
          } else if ($('input[name="store-option"]', el).length == 0) {
            $('button[type="submit"]', el).attr('disabled', 'disabled');
          }
        }
      }, 1000);

      book_a_demo.slider.updateEl();
    },
  },
  product_reselection: {
    init: (el) => {
      // if (book_steps.res.hasOwnProperty(book_steps.id)) return;

      let product_ids = book_steps.inputs['product_id'];
      book_steps.inputs['product_id'] = product_ids.length > 1 ? [product_ids.shift()] : product_ids;

      var products = book_steps.datas['products'];
      book_steps.datas['products'] = products.length > 1 ? [products.shift()] : products;

      $('.book-demo-product-list', el).html('');

      if (book_steps.json !== false) {
        var product_2 = book_steps.json.product_2[book_steps.inputs['store_id']] || [];
        product_2 = product_2.filter((product) => {
          return !book_steps.inputs['product_id'].includes(product);
        });
        var data = [];
        Object.values(product_2).forEach((product, key) => {
          data.push(book_steps.json.product[product]);
        });
        book_steps.product_reselection.setUi(el, data);
      } else {
        var ajaxes = [];
        book_steps.res[book_steps.id] = book_steps.res['product_selection'];
        var product_selection = book_steps.res['product_selection'];
        var products = product_selection.products.filter((d, i) => {
          return book_steps.inputs['product_id'].indexOf(d.activityExternalId) < 0;
        });
        $.each(products, (i, product) => {
          ajaxes.push(
            book_steps.initAjax({
              shop: _BAD.data_shop,
              action: 'product-reselection',
              timestamp: _BAD.data_timestamp,
              signature: _BAD.data_signature,

              external_id: book_steps.inputs['external_id'] || '',
              product_id: product.activityExternalId,
              store_id: book_steps.inputs['store_id'],
            })
          );
        });

        $.when(...ajaxes).done(function(...datas) {
          if (ajaxes.length == 1) {
            datas = [datas];
          }

          var new_products = [];
          $.each(datas, (i, data) => {
            var res = data[0];
            $.each(products, (j, product) => {
              if (res.product_id == product.activityExternalId && res.store_available) {
                new_products.push(product);
              }
            });
          });

          book_steps.product_reselection.setUi(el, new_products);

        }).fail(function(fail) {

          let hb_data = Object.assign({
            texts: _BAD_TEXTS['product_reselection']['error_page'],
          });
          let tpl = Handlebars.compile($('#error-page-hb').html());
          $('.book-demo-product-list', el).html(tpl(hb_data));
        });
      }

      var answered_id = [];
      var total_answers = _BAD.product2_selection_limit;
      $(document).off('click', '.book-demo-product-option-2nd');
      $(document).on('click', '.book-demo-product-option-2nd', function(e) {
        var _t = $(this);
        var _t_input = _t.find('input');

        if (_t_input.attr('type') == 'radio') {
          _t.addClass('active')
            .siblings().removeClass('active')
            .find('input').prop('checked', false);

          _t_input.prop('checked', true).trigger('change');
        } else {
          if (! _t_input.prop('checked')) {
            _t.addClass('active');
            _t_input.prop('checked', true).trigger('change');
          } else {
            _t.removeClass('active');
            _t_input.prop('checked', false).trigger('change');
          }

          if (total_answers == 1) {
            _t.siblings().removeClass('active')
              .find('input').prop('checked', false);
          } else {
            // multianswer
            var _t_val = _t_input.val();
            if (_t_input.prop('checked')) {
              answered_id.push(_t_val);
            } else {
              var pop_idx = answered_id.indexOf(_t_val);
              answered_id.splice(pop_idx, 1);
            }
            if (answered_id.length > total_answers) {
              var pop_val = answered_id.shift();
              $(`.book-demo-product-option-2nd input[value="${pop_val}"]`, el).prop('checked', false).trigger('change')
                .parents(`.book-demo-product-option-2nd`).removeClass('active');
            }
          }
        }

        e.preventDefault();
      });

      book_a_demo.validator.validate({
        errorLabelContainer: '.product-reselection-form-error',
        submitHandler: function(form) {
          let product_id = [];
          $('input[name="product-option2[]"]:checked', el).each(function() {
            product_id.push($(this).val());
            book_steps.inputs['product_id'].push($(this).val());
          });

          $('input[name="product-option2[]"]:checked', el).each(function() {
            book_steps.datas['products'].push(JSON.parse($(this).attr('data-record')));
          });

          book_a_demo.validator.destroy();

          book_a_demo.slider.slideNext();

          // gtm
          book_steps.pushGtm({
            event: 'product_reselection_next_step',
            gtmValue: product_id.join(','),
          });
          // hkmci
          if (book_steps.datas['products'].length == 1) {
            pushToDataLayer('skip_demo_second_product', {
            });
          } else {
            pushToDataLayer('select_demo_second_product', {
              'item_id': book_steps.datas['products'][1]['activityExternalId'],
              'item_name': book_steps.datas['products'][1]['activityName'],
              'item_variant': '',
              'item_category': book_steps.datas['products'][1]['collectionName'],
              'item_category2': ''
            });
          }

          return false;
        }
      });
    },
    setUi: (el, data) => {
      if (data.length == 0) {
        setTimeout(() => {
          $('form', el).submit();
        }, 500);
      }

      let products = [];
      let product = {};
      _BAD.product_data.forEach((product_data) => {
        product_data.handles.forEach((handle) => {
          var activity_product = data.filter(function(data) {
            return data.activityExternalId == handle;
          });
          if (activity_product.length == 0) return;
          product = activity_product[0];
          product['activityName'] = _BAD.product_texts.products[handle] || product['activityName'];
          product['collectionId'] = product_data.collection_handle;
          product['collectionName'] = _BAD.product_texts.categories[product_data.collection_handle] || product_data.title;
          products.push(product);
        });
      });
      let hb_data = Object.assign({
        // products: data
        products: products
      }, {
        asset_url: _BAD.asset_url,
        input_id: 'book-demo-product-option2-',
        input_name: 'product-option2[]',
        texts: _BAD_TEXTS['product_reselection'],
      });
      let tpl = Handlebars.compile($('#product-reselection-list-hb').html());
      $('.book-demo-product-list', el).html(tpl(hb_data));

      book_a_demo.slider.updateEl();

      setTimeout(() => {
        // let btn_submit = $('button[type="submit"]', el);
        let btn_submit = $('> .book-demo-wrapper-nav button[type="submit"]', wrapper_id);
        let btn_submit_text = btn_submit.html();
        el.on('change', 'input[name="product-option2[]"]', function() {
          $('input[name="product-option2[]"]:checked', el).length > 0
            ? btn_submit.html(btn_submit.attr('data-checked'))
            : btn_submit.html(btn_submit_text);
        });

        // always disable submit button
        btn_submit.removeAttr('disabled');
      }, 500);
    },
  },
  calendar_form: {
    init: (el) => {
      // if (book_steps.res.hasOwnProperty(book_steps.id)) return;

      $('.book-demo-calendar-time-wrapper > div', el).html('');

      book_a_demo.fullcalendar.init();

      book_a_demo.validator.validate({
        rules: {
          'date-time-option': {
            required: true,
          },
        },
        messages: {
          'date-time-option': {
            required: _BAD_TEXTS.calendar_form.form.error.date_time_slot,
          },
        },
        errorLabelContainer: '.calendar-form-error',
        submitHandler: function(form) {
          var input_checked = $('input[name="date-time-option"]:checked', el);
          book_steps.inputs['date_time'] = '';
          book_steps.inputs['date_time'] = input_checked.val();
          book_steps.inputs['duration'] = '';
          book_steps.inputs['duration'] = input_checked.attr('data-duration');

          book_steps.datas['date_time_slot'] = {};
          var d = JSON.parse(input_checked.attr('data-record'))
          book_steps.datas['date_time_slot'] = d;
          let dt_option = {
            zone: book_steps.datas['store'].timezone,
          };
          if (_BAD.calendar_localize_date) {
            dt_option.locale = _BAD.locale;
          }
          // let dt = luxon.DateTime.fromISO(d.appointmentSlotTime).setZone(book_steps.datas['store'].timezone, { keepLocalTime: true });
          let dt = luxon.DateTime.fromISO(d.appointmentSlotTime, {
            zone: book_steps.datas['store'].timezone
          });
          if (_BAD.calendar_localize_date) {
            dt = dt.setLocale(_BAD.locale);
          }
          let dt_date = dt.toFormat('cccc, LLL dd, yyyy,');
          let dt_time = dt.toFormat('h:mm a').toLowerCase();
          book_steps.datas['date_time_slot'].dt = dt;
          book_steps.datas['date_time_slot'].human_date = `${dt_date} ${dt_time}`;

          book_a_demo.validator.destroy();

          book_a_demo.slider.slideNext();

          // gtm
          book_steps.pushGtm({
            event: 'calendar_form_next_step',
            gtmValue: book_steps.datas['date_time_slot'].human_date,
          });
          // hkmci
          let dt_today = luxon.DateTime.now();
          pushToDataLayer('select_demo_datetime', {
            'advanced_days': parseInt(dt.diff(dt_today, 'days').toObject()['days']),
          });

          return false;
        }
      });
    },
    initAjaxData: () => {
      var ajaxes = [];
      $.each(book_steps.inputs['product_id'], (i, product_id) => {
        ajaxes.push(
          book_steps.initAjax({
            shop: _BAD.data_shop,
            action: 'calendar-form',
            timestamp: _BAD.data_timestamp,
            signature: _BAD.data_signature,
    
            external_id: book_steps.inputs['external_id'] || '',
            product_id: product_id,
            store_id: book_steps.inputs['store_id'],
            program_external_id: book_steps.inputs['program_external_id'] || '',
            start_date: book_steps.inputs['start_date'],
            end_date: book_steps.inputs['end_date'],
          })
        );
      });

      $.when(...ajaxes).done(function(...datas) {
        if (ajaxes.length == 1) {
          datas = [datas];
        }

        book_steps.inputs['program_external_id'] = datas[0][0].program_external_id;
        let first_data = datas[0];
        first_data = first_data[0];
        first_data.all_slots = first_data['return'] || [];
        // reset slots
        first_data.slots = false;
        $.each(datas, (i, data) => {
          // all slots
          let res = data[0];
          let all_slots = res['return'] || [];
          first_data.all_slots = first_data.all_slots.filter((value) => {
            return all_slots.some((value2) => {
              return (value.appointmentSlotTime === value2.appointmentSlotTime) && value2.is_available;
            }) && value.is_available;
          });

          // slots
          let slots = first_data.all_slots.reduce(function (r, a) { // set object key with date string
            let date = luxon.DateTime.fromJSDate(new Date(a.appointmentSlotTime)).setZone(book_steps.datas['store'].timezone);
            a.date = date.toFormat('yyyy-MM-dd');
            
            let start_time = luxon.DateTime.fromJSDate(new Date(a.appointmentSlotTime)).setZone(book_steps.datas['store'].timezone);
            start_time = start_time.toFormat('T');
            
            let end_time = luxon.DateTime.fromJSDate(new Date(a.appointmentSlotTime)).setZone(book_steps.datas['store'].timezone).plus({ 'minutes' : a.lengthinMin });
            end_time = end_time.toFormat('T');
            
            a.time = `${start_time} - ${end_time}`;
            a.start_time = start_time;
            a.end_time = end_time;
            
            a.is_available = a.slotStatus == 'Available';
            
            r[a.date] = r[a.date] || [];
            r[a.date].push(a);
            return r;
          }, Object.create(null));

          if (first_data.slots === false) first_data.slots = slots;
          first_data.slots = Object.keys(first_data.slots).filter((key) => {
            return new Date(key).getTime() <= new Date(book_steps.inputs['end_date']).getTime();
            // return key in slots;
          }).reduce((obj, key) => {
            obj[key] = first_data.slots[key];
            return obj;
          }, {});
          $.each(first_data.slots, (date, slots_data) => {
            first_data.slots[date] = first_data.slots[date].filter((value) => {
              return slots[date].some((value2) => {
                return (value.appointmentSlotTime === value2.appointmentSlotTime) && value2.is_available;
              }) && value.is_available;
            });
          });
        });

        book_steps.res[book_steps.id] = first_data;

        book_a_demo.fullcalendar.updateEventsCalendar(first_data.slots || [], book_steps.inputs['end_date']);

        book_a_demo.slider.updateEl();
      }).fail(function(fail) {
        let hb_data = Object.assign({
          texts: _BAD_TEXTS['calendar_form']['error_page'],
        });
        let tpl = Handlebars.compile($('#error-page-hb').html());
        $('.book-demo-calendar-time-wrapper > div', book_steps.el).html(tpl(hb_data));
      });
    },
    initTimeWrapper: (date, delay = 1000) => {
      $('.book-demo-calendar-time-wrapper > div', book_steps.el).html('');

      setTimeout(() => {
        let data = book_steps.res[book_steps.id];
        let slots = data.slots || {};
      
        let date_slots = Object.keys(slots);
        data.date_slots = date_slots || [];
  
        let time_slots = slots[date] || [];
        $.each(time_slots, (i, slot) => {
          var date = luxon.DateTime.fromISO(slot.appointmentSlotTime, {
            zone: book_steps.datas['store'].timezone
          });
          time_slots[i].start_time = date.toFormat('HH:mm');
          time_slots[i].end_time = date.plus({minutes: slot.lengthinMin}).toFormat('HH:mm');
          time_slots[i].time = `${time_slots[i].start_time} - ${time_slots[i].end_time}`;
        });
        data.time_slots = time_slots || [];
  
        let hb_data = Object.assign(data, {
          input_id: 'book-demo-calendar-time-',
          input_name: 'date-time-option',
          texts: _BAD_TEXTS['calendar_form'],
        });
        let tpl = Handlebars.compile($('#calendar-time-list-hb').html());
        $('.book-demo-calendar-time-wrapper > div', book_steps.el).html(tpl(hb_data)).scrollTop(0);
        $('#book-demo-appointment-calendar').removeClass('loading');
  
        book_steps.res[book_steps.id] = data;

        book_a_demo.slider.updateEl();

        book_a_demo.validator.checkValidate(book_steps.id);
      }, delay);
    },
  },
  appointment_form: {
    init: (el) => {
      book_a_demo.validator.validate({
        rules: {
          'salutation': {
            required: true,
          },
          'first_name': {
            required: true,
          },
          'last_name': {
            required: true,
          },
          'email': {
            required: true,
            email: true,
          },
          'mobile_phone': {
            required: true,
          },
          // 'message': {
          //   required: true,
          // },
          'terms': {
            required: true,
          },
          // 'newsletter': {
          //   required: true,
          // },
        },
        messages: {
          'salutation': {
            required: _BAD_TEXTS.appointment_form.form.error.salutation,
          },
          'first_name': {
            required: _BAD_TEXTS.appointment_form.form.error.first_name,
          },
          'last_name': {
            required: _BAD_TEXTS.appointment_form.form.error.last_name,
          },
          'email': {
            required: _BAD_TEXTS.appointment_form.form.error.email,
            email: _BAD_TEXTS.appointment_form.form.error.email_valid,
          },
          'mobile_phone': {
            required: _BAD_TEXTS.appointment_form.form.error.phone,
          },
          // 'message': {
          //   required: _BAD_TEXTS.appointment_form.form.error.message,
          // },
          'terms': {
            required: _BAD_TEXTS.appointment_form.form.error.terms,
          },
          // 'newsletter': {
          //   required: _BAD_TEXTS.appointment_form.form.error.newsletter,
          // },
        },
        errorPlacement: function(error, element) {
          error.appendTo(element.parents('.form-group'));
        },
        submitHandler: function(form) {
          $('#book-a-demo button[type="submit"]').attr('disabled', 'disabled');

          book_steps.inputs['appt_form'] = {};
          $.each($(form).serializeArray(), function(i, input) {
            book_steps.inputs['appt_form'][input.name] = input.value;
          });
          book_steps.inputs['appt_form']['terms'] = book_steps.inputs['appt_form']['terms'] || '0';
          book_steps.inputs['appt_form']['newsletter'] = book_steps.inputs['appt_form']['newsletter'] || '0';
          book_steps.inputs['appt_form']['has_message'] = book_steps.inputs['appt_form']['message'] != '';

          book_steps[book_steps.id].createClient();

          return false;
        }
      });
    },
    createClient: () => {
      // create client
      book_steps.initAjax({
        shop: _BAD.data_shop,
        action: 'client-store',
        timestamp: _BAD.data_timestamp,
        signature: _BAD.data_signature,

        external_id: book_steps.inputs['external_id'] || '',
        salutation: book_steps.inputs['appt_form'].salutation,
        first_name: book_steps.inputs['appt_form'].first_name,
        last_name: book_steps.inputs['appt_form'].last_name,
        email: book_steps.inputs['appt_form'].email,
        mobile_phone: book_steps.inputs['appt_form'].mobile_phone,
      }).done(function(data, textStatus, jqXHR) {
        book_steps.inputs['client_id'] = data.client_id;

        book_steps[book_steps.id].createAppointment();

      }).fail(function(jqXHR, textStatus, errorThrown) {
      });
    },
    createAppointment: () => {
      // create appointment
      var ajaxes = [];
      let first_product_id = book_steps.inputs['product_id'].shift();
      let product_datas = book_steps.datas['products'];
      let second_product_names = [];
      $.each(product_datas, (i, product_data) => {
        if (i == 0) return;
        second_product_names.push(product_data['activityName']);
      });
      let second_product_name = second_product_names.join(',');

      var date = luxon.DateTime.fromISO(book_steps.inputs['date_time'], {
        zone: book_steps.datas['store'].timezone
      });
      let local_start_date_time = date.toFormat('HH:mm');
      let local_end_date_time = date.plus({minutes: book_steps.inputs['duration']}).toFormat('HH:mm');
      let local_timezone = date.setZone(book_steps.datas['store'].timezone).toFormat('Z').replace('+', '');
      let utc_start_date_time = date.toFormat('hh:mm');
      let utc_end_date_time = date.plus({minutes: book_steps.inputs['duration']}).toFormat('hh:mm');
      let utc_timezone = book_steps.datas['store'].timezone;

      ajaxes.push(
        book_steps.initAjax({
          shop: _BAD.data_shop,
          action: 'appointment-store',
          timestamp: _BAD.data_timestamp,
          signature: _BAD.data_signature,
  
          external_id: book_steps.inputs['external_id'] || '',
          product_id: first_product_id,
          add_product_id: second_product_name,
          store_id: book_steps.inputs['store_id'],
          program_external_id: book_steps.inputs['program_external_id'] || '',
          local_start_date_time: local_start_date_time,
          local_end_date_time: local_end_date_time,
          local_timezone: local_timezone,
          utc_start_date_time: utc_start_date_time,
          utc_end_date_time: utc_end_date_time,
          utc_timezone: utc_timezone,
  
          date_time: book_steps.inputs['date_time'],
          duration: book_steps.inputs['duration'],
  
          message: book_steps.inputs['appt_form'].message,
          terms: book_steps.inputs['appt_form'].terms,
          newsletter: book_steps.inputs['appt_form'].newsletter,
          client_id: book_steps.inputs['client_id'],
        })
      );

      $.when(...ajaxes).done(function(...datas) {
        if (ajaxes.length == 1) {
          datas = [datas];
        }

        book_steps.inputs['appointment_id'] = [];
        $.each(datas, (i, data) => {
          let res = data[0];
          book_steps.inputs['appointment_id'].push(res.appointment_id);
        });

        book_a_demo.slider.slideNext();

        // gtm
        book_steps.pushGtm({
          event: 'appointment_form_next_step',
        });
        // hkmci
        pushToDataLayer('complete_demo_booking', {
          'newsletter_registration': Boolean(book_steps.inputs['appt_form'].newsletter).toString()
        });

      }).fail(function(fail) {
        // let err_txt = `${_BAD_TEXTS['appointment_form']['error_page']['title_html']} ${_BAD_TEXTS['appointment_form']['error_page']['text_html']}`;
        // $('.appointment-form-error', el).html(err_txt);
        // TODO
        book_a_demo.slider.slideNext();
      });
    },
  },
  appointment_confirmation: {
    init: (el) => {
      book_steps.appointment_confirmation.initScript(el)

      // gtm
      book_steps.pushGtm({
        event: 'appointment_confirmation_success',
      });
      // hkmci
      $('#book-a-demo').on('click', 'add-to-calendar-button', function(e) {
        // https://add-to-calendar-button.com/advanced-use#case-7
        // grab event value from dataLayer by latest order
        var calendar_type = dataLayer.sort().reverse().filter((d) => d.event == 'openCalendarLink');
        if (calendar_type.length > 0) {
          pushToDataLayer('click_add_demo_calendar', {
            'calendar_type': calendar_type[0].eventLabel.replace(`${e.target.identifier}-`, '')
          });
        }
      });
    },
    initScript: (el) => {
      const event_data = {
        title: _BAD_TEXTS.appointment_confirmation.add_to_calendar.ics_title,
        description: _BAD_TEXTS.appointment_confirmation.add_to_calendar.ics_description,
        start: book_steps.datas['date_time_slot'].appointmentSlotTime,
        duration: `${book_steps.datas['date_time_slot'].date} ${book_steps.datas['date_time_slot'].start_time}`,
        location: book_steps.datas['date_time_slot'].lengthinMin,
        
        name: _BAD_TEXTS.appointment_confirmation.add_to_calendar.ics_title,
        description: _BAD_TEXTS.appointment_confirmation.add_to_calendar.ics_description,
        location: book_steps.datas['store'].display_name,
        startDate: book_steps.datas['date_time_slot'].date,
        startTime: book_steps.datas['date_time_slot'].start_time,
        endDate: book_steps.datas['date_time_slot'].date,
        endTime: book_steps.datas['date_time_slot'].end_time,
        timeZone: book_steps.datas['date_time_slot'].dt.toFormat('z'),
        options: `'Apple','Google','Outlook.com','Microsoft365|Office 365'`,
        buttonStyle: 'custom',
        customCss: _BAD.atcb_css_url,
        listStyle: 'dropdown',
        label: _BAD_TEXTS['appointment_confirmation'].add_to_calendar.btn,
        hideBackground: true,
        // debug: true,
      };

      // summary
      let hb_data = Object.assign(book_steps.datas, {
        texts: _BAD_TEXTS['appointment_confirmation'],
        store: book_steps.datas['store'],
        appointment: book_steps.inputs['appt_form'],
        appt_datas: event_data,
      });
      let tpl = Handlebars.compile($('#appointment-details-hb').html());
      $('.book-demo-appt-box-info', book_steps.el).html(tpl(hb_data));

      // map
      if ($('#appointment-map-hb').length == 1) {
        hb_data = Object.assign({
          texts: _BAD_TEXTS['appointment_confirmation'],
          map: {
            data_country: _BAD.map_country,
            data_store: book_steps.datas['store'].resourceExternalId,
            zoom: _BAD.map_zoom_single_store,
            source: _BAD.map_source,
          },
        });
        tpl = Handlebars.compile($('#appointment-map-hb').html());
        $('.book-demo-appt-box-map', el).html(tpl(hb_data));

        book_a_demo.slider.updateEl();

        var ivt = setInterval(() => {
          if ($('#dealer-locator-confirmation').length == 1) {
            book_a_demo.map.init('dealer-locator-confirmation');
          }
          if ($('.book-demo-appt-box-map .dealer-locator').html() != '') {
            clearInterval(ivt);
            book_a_demo.slider.updateEl();
          }
          book_a_demo.slider.updateEl();
        }, 500);
      }

      // atc btn
      if ($('.btn-add-calendar').length > 0) {
        var ical_script = document.createElement('script');
        ical_script.src = 'https://cdn.jsdelivr.net/npm/add-to-calendar-button@2';
        ical_script.type = 'text/javascript';
        document.getElementsByTagName('head')[0].appendChild(ical_script);
        ical_script.onload = () => {
        }
      }

      book_a_demo.slider.updateEl();

      book_a_demo.slider.destroyEl();
    },
  },
  appointment_get: {
    init: (el) => {
      let params = general.getUrlVars()

      if (!params.hasOwnProperty('appointment_id') || !params.hasOwnProperty('client_id')) {
        let hb_data = Object.assign({
          texts: _BAD_TEXTS['appointment_get']['error_page'],
        });
        let tpl = Handlebars.compile($('#error-page-hb').html());
        $('.book-demo-appointment-details', el).html(tpl(hb_data));

        book_a_demo.slider.destroyEl();
        return;
      }
      // if (book_steps.res.hasOwnProperty(book_steps.id)) return;

      let ajaxes = []
      ajaxes.push(
        book_steps.initAjax({
          shop: _BAD.data_shop,
          action: 'appointment-get',
          timestamp: _BAD.data_timestamp,
          signature: _BAD.data_signature,

          appointment_id: params['appointment_id'],
          client_id: params['client_id'],
        })
      );
      $.when(...ajaxes).done(function(...datas) {
        if (ajaxes.length == 1) {
          datas = [datas];
        }
        let data = datas[0][0];
        let sf_data = data.appointment_sf;
        sf_data = sf_data.recordSize > 0 ? sf_data.records[0] : {};
        
        let appt = data.appointment;
        book_steps.datas['store'] = {
          timezone: sf_data['bookingDemoTimezone'] || appt['clientTimezone'],
          resourceExternalId: appt['resourceExternalId'],
          resourceName: sf_data['bookingRetailer'] != null ? sf_data['bookingRetailer']['Name'] : appt['resourceName'],
          description: sf_data['bookingRetailer'] != null ? `${sf_data['bookingRetailer']['MailingStreet'] || ''} ${sf_data['bookingRetailer']['MailingCity'] || ''} ${sf_data['bookingRetailer']['MailingCountry'] || ''}`.trim() : '',
        }
        book_steps.datas['store']['has_description'] = book_steps.datas['store']['description'] != '';
        book_steps.datas['products'] = [{
          activityName: appt['activityName'],
        }]
        if (sf_data['bookingProduct2Name'] !== null) {
          book_steps.datas['products'].push({
            activityName: sf_data['bookingProduct2Name'],
          });
        }
        book_steps.inputs['appt_form'] = {
          salutation: sf_data['salutation'],
          first_name: appt['clientFirstname'] || sf_data['customerFirstName'],
          last_name: appt['clientLastname'] || sf_data['suppliedName'],
          email: sf_data['suppliedEmail'],
          mobile_phone: sf_data['suppliedPhone'],
          message: sf_data['bookingRemark'],
        }
        book_steps.inputs['appt_form']['has_message'] = book_steps.inputs['appt_form']['message'];
        book_steps.inputs['appointment_id'] = params['appointment_id']
        book_steps.inputs['client_id'] = params['client_id']
        book_steps.inputs['external_id'] = appt['locationExternalId']
        book_steps.inputs['product_id'] = [
          appt['activityExternalId']
        ]
        book_steps.inputs['store_id'] = appt['resourceExternalId']
        book_steps.inputs['program_external_id'] = appt['programExternalId']

        book_a_demo.slider.slideNext();
      }).fail(function(jqXHR, textStatus, errorThrown) {
        let hb_data = Object.assign({
          texts: _BAD_TEXTS['appointment_get']['error_page'],
        });
        let tpl = Handlebars.compile($('#error-page-hb').html());
        $('.book-demo-appointment-details', el).html(tpl(hb_data));

        book_a_demo.slider.destroyEl();
      });
    },
  },

  // reschedule
  calendar_form_reschedule: {
    init: (el) => {
      $('.book-demo-calendar-time-wrapper > div', el).html('');

      book_a_demo.fullcalendar.init();

      book_a_demo.validator.validate({
        rules: {
          'date-time-option': {
            required: true,
          },
        },
        messages: {
          'date-time-option': {
            required: _BAD_TEXTS.calendar_form.form.error.date_time_slot,
          },
        },
        errorLabelContainer: '.calendar-form-error',
        submitHandler: function(form) {
          $('button[type="submit"]', form).attr('disabled', 'disabled');

          book_steps.inputs['date_time'] = '';
          book_steps.inputs['date_time'] = $('input[name="date-time-option"]:checked', el).val();
          book_steps.inputs['duration'] = '';
          book_steps.inputs['duration'] = $('input[name="date-time-option"]:checked', el).attr('data-duration');

          book_steps.datas['date_time_slot'] = {};
          $.each(book_steps.res[book_steps.id].all_slots, function(i, d) {
            if (book_steps.inputs['date_time'] == d.appointmentSlotTime) {
              book_steps.datas['date_time_slot'] = d;

              let dt = luxon.DateTime.fromISO(d.appointmentSlotTime, {
                zone: book_steps.datas['store'].timezone
              });
              let dt_date = dt.toFormat('cccc, LLL dd, yyyy,');
              let dt_time = dt.toFormat('h:mm a').toLowerCase();
              book_steps.datas['date_time_slot'].dt = dt;
              book_steps.datas['date_time_slot'].human_date = `${dt_date} ${dt_time}`;
            }
          });
          
          book_steps[book_steps.id].rescheduleAppointment();

          // gtm
          book_steps.pushGtm({
            event: 'reschedule_calendar_form_next_step',
            gtmValue: book_steps.datas['date_time_slot'].human_date,
          });

          return false;
        }
      });
    },
    initAjaxData: () => {
      book_steps['calendar_form'].initAjaxData();
    },
    initTimeWrapper: (date, delay = 1000) => {
      book_steps['calendar_form'].initTimeWrapper();
    },
    rescheduleAppointment: () => {
      // reschedule appointment
      book_steps.initAjax({
        shop: _BAD.data_shop,
        action: 'appointment-reschedule',
        timestamp: _BAD.data_timestamp,
        signature: _BAD.data_signature,

        appointment_id: book_steps.inputs['appointment_id'],
        date_time: book_steps.inputs['date_time'],
      }).done(function(data, textStatus, jqXHR) {
        book_a_demo.slider.slideNext();

      }).fail(function(jqXHR, textStatus, errorThrown) {
      });
    },
  },
  appointment_reschedule_confirmation: {
    init: (el) => {
      book_steps.appointment_confirmation.initScript(el)

      // gtm
      book_steps.pushGtm({
        event: 'reschedule_confirmation_success',
      });
    },
  },
}

book_a_demo.init();

Handlebars.registerHelper('toJSON', function(obj) {
  return JSON.stringify(obj, null, 3);
});